import React from "react"
import wantToCry from '../../img/icon/want-to-cry.png';

export default function WantToCry() {
   return (
      <img src={wantToCry} alt="" />
   )
}
